import React from "react";
import "./Footer.css";
import { Link, useLocation } from "react-router-dom";
import { Nav } from "react-bootstrap";
import { faEnvelope, faGlobe, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Footer = () => {
  const location = useLocation();

  return (
    <>
      <section className="Footer">
        <div className="container">
          <div className="heading_holder">
            <h1>AYANSH INTERNATIONAL TRADING FZ-LLC</h1>
          </div>

          <div className="footer_main_link_holder">
            <Nav.Link as={Link} to="/" className={location.pathname === "/" ? "active" : ""}>
              Home
            </Nav.Link>
            <Nav.Link as={Link} to="/about-us" className={location.pathname === "/about-us" ? "active" : ""}>
              About Us
            </Nav.Link>
            <Nav.Link as={Link} to="/products" className={location.pathname === "/products" ? "active" : ""}>
              Products
            </Nav.Link>
            <Nav.Link as={Link} to="/contact" className={location.pathname === "/contact" ? "active" : ""}>
              Contact
            </Nav.Link>
          </div>

          <div className="footer_links_holder">
            <div className="row">
              {/* Office Addresses */}
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="title_link">
                  <h6>UAE Office:</h6>
                </div>
                <p>
                  SFF00014 Compass Building,<br />
                  Al Shohada Road,<br />
                  AL Hamra Industrial Zone-FZ,<br />
                  RAS AL KHAIMAH, United Arab Emirates
                </p>

                <div className="title_link">
                  <h6>Rwanda Office:</h6>
                </div>
                <p>
                  006/45, Cyangugu,<br />
                  Kamembe, RUSIZI
                </p>

                <div className="title_link">
                  <h6>Uganda Office:</h6>
                </div>
                <p>
                  Shop No. B1,<br />
                  Nakiyubo Road,<br />
                  Kampala, Uganda
                </p>
              </div>

              {/* Contact Info */}
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="title_link">
                  <h6>Contact us:</h6>
                </div>

                <Link to="mailto:info@ayanshinternational.com" target="_blank" className="footer_link">
                  <p>
                    <FontAwesomeIcon className="footer_contact_icon" icon={faEnvelope} /> info@ayanshinternational.com
                  </p>
                </Link>

                <Link to="mailto:sales@ayanshinternational.com" target="_blank" className="footer_link">
                  <p>
                    <FontAwesomeIcon className="footer_contact_icon" icon={faEnvelope} /> sales@ayanshinternational.com
                  </p>
                </Link>

                <Link to="mailto:support@ayanshinternational.com" target="_blank" className="footer_link">
                  <p>
                    <FontAwesomeIcon className="footer_contact_icon" icon={faEnvelope} /> support@ayanshinternational.com
                  </p>
                </Link>

                <Link to="tel:+971502146919" target="_blank" className="footer_link">
                  <p>
                    <FontAwesomeIcon className="footer_contact_icon" icon={faPhone} /> +971 502 146 919
                  </p>
                </Link>

                <Link to="https://www.ayanshinternational.com/" target="_blank" className="footer_link">
                  <p>
                    <FontAwesomeIcon className="footer_contact_icon" icon={faGlobe} /> www.ayanshinternational.com
                  </p>
                </Link>
              </div>

              {/* Support Links */}
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="title_link">
                  <h6>Support:</h6>
                </div>
                <Link to="/terms-and-condition">
                  <p>Terms and Conditions</p>
                </Link>
                <Link to="/privacy-policy">
                  <p>Privacy Policy</p>
                </Link>
              </div>
            </div>
          </div>

          <div className="footer_copyright_holder">
            <p>
              Copyright ©2025 All Rights Reserved. Developed by{" "}
              <Link to="https://www.profcymaglobal.com/" target="_blank">
                <span>Profcyma</span>
              </Link>.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Footer;
